"use client";
import { CssBaseline, ThemeProvider as MuiThemeProvider } from "@mui/material";
import InitColorSchemeScript from "@mui/material/InitColorSchemeScript";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v13-appRouter";
import type { ReactNode } from "react";
import { createMuiTheme } from "./main";

export default function ThemeProvider({
	children,
}: Readonly<{ children: ReactNode }>) {
	const theme = createMuiTheme();

	return (
		<>
			<InitColorSchemeScript />
			<AppRouterCacheProvider options={{ enableCssLayer: true }}>
				<MuiThemeProvider theme={theme}>
					<CssBaseline enableColorScheme />
					{children}
				</MuiThemeProvider>
			</AppRouterCacheProvider>
		</>
	);
}
